import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Form = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M16.69 2.83c1.1-1.1 2.9-1.1 4 0l.48.48c1.1 1.1 1.1 2.9 0 4l-7.76 7.77c-.34.34-.77.59-1.23.72l-3.94 1.13a.9.9 0 0 1-.93-.28c-.24-.2-.33-.56-.24-.9l1.13-3.93c.13-.46.38-.88.72-1.23l7.77-7.76Zm2.63 1.34a.9.9 0 0 0-1.3 0L16.88 5.3l1.81 1.82 1.15-1.18a.9.9 0 0 0 0-1.3l-.52-.48Zm-9.3 8.17-.66 2.3 2.3-.66c.16-.04.3-.12.4-.24l5.3-5.28-1.82-1.81-5.28 5.28a.92.92 0 0 0-.24.41Zm-.15-7.97a.94.94 0 1 1 0 1.89h-4.4c-.88 0-1.58.7-1.58 1.57v10.7c0 .88.7 1.58 1.57 1.58h10.71c.87 0 1.58-.7 1.58-1.57v-4.41a.94.94 0 1 1 1.89 0v4.4A3.46 3.46 0 0 1 16.17 22H5.47A3.46 3.46 0 0 1 2 18.54V7.84a3.46 3.46 0 0 1 3.46-3.47h4.41Z"
    />
  </svg>
));
